<template>
  <b-container>
    <b-row>
      <h2>Dictionary</h2>
    </b-row>
    <b-row>
      <b-col cols="9">
      <b-form @submit.prevent="retrieveDefinition">
      <b-form-group label="Choose your dictionary" label-align="left">
        <b-form-select v-model="selectedDictionary" :options="options" size="sm" class="mt-3"></b-form-select>
      </b-form-group>
      <b-form-group label="Enter the word" label-align="left" v-if="selectedDictionary">
        <b-form-input type="text" v-model="token"/>
      </b-form-group>
      <b-button type="submit" :disabled="noSearchPossible">Search</b-button>
      </b-form>
      </b-col>
    </b-row>
    <b-row>
      <p v-html="definition" style="text-align: start"/>
    </b-row>
    <b-row>
      <p>{{ message }}</p>
    </b-row>
  </b-container>
</template>

<script>

import {lookup} from "../api/dictionary";
export default {
  name: "Dictionary",
  data: function() {
    return {
      options: [
        {text: "Zoëga's dictionary (Norse to English)", value: "cltk_non_zoega_dictionary"},
        {text: "Lewis' dictionary (Latin to English)", value: "cltk_lat_lewis_elementary_lexicon"},
      ],
      selectedDictionary: '',
      token: '',
      definition: '',
      message: ''
    }
  },
  methods: {
    retrieveDefinition: function() {
      lookup(this.selectedDictionary, this.token).then(
          response => {
            if(response.data.success) {
              let definition = response.data.definition;
              this.definition = definition.replaceAll("\n", "<br>");
              // console.log(this.definition);
              // this.definition = this.definition.replace(";", "<br>");
              console.log(this.definition);
              this.message = "";
            } else {
              this.definition = "";
              this.message = response.data.message;
            }
          }
      ).catch(
          () => {
            this.definition = "";
            this.message = "There is an error somewhere, probably the developer's fault, or maybe your Internet connection."
          }
      );
    }
  },
  computed: {
    noSearchPossible: function() {
      return this.token.length === 0 || !this.selectedDictionary;
    }
  }
}
</script>

<style scoped>

</style>